import Cookies from 'js-cookie';
import jwtDecode from 'jwt-decode';

export const LOCAL_STORAGE_SESSION_KEY = 'platfi-ui-app/SESSION';
export const LOCAL_STORAGE_SESSION_MARKETPLACE_KEY = 'platfi-ui-app/SESSION/MARKETPLACE';
const COOKIE_SESSION_KEY = 'jwtToken';
const PHP_SESSION_KEY = 'PHPSESSID';

const Session = {};

/**
 * @name getTokenFromStorage
 * @description
 * Method that checks the localStorage for the session information
 * and returns it. The result is also parser from JSON to an object.
 */
function getTokenFromStorage(key) {
  try {
    // Load the token from the localStorage
    const session = JSON.parse(localStorage.getItem(key));

    // Reject token
    if (Session.isExpired(session.expiresAt)) {
      return null;
    }

    // Return the token and the decoded payload
    return {
      ...session,
      tokenPayload: Session.decodeToken(session.accessToken),
    };
  } catch (error) {
    return null;
  }
}

/**
 * @name getTokenFromCookie
 * @description
 * Method that checks the cookie for an token provided by the
 * legacy app. If a token is found it will be decoded to extract
 * the expireAt field.
 */
function getTokenFromCookie() {
  const token = Cookies.get(COOKIE_SESSION_KEY);

  if (!token) {
    return null;
  }

  const decoded = Session.decodeToken(token);

  return {
    accessToken: token,
    expiresAt: decoded.exp,
    tokenPayload: decoded,
  };
}

/**
 * @name get
 * @description
 * Method that returns the current session from storage.
 * It will first try to find it on the localStorage and
 * if not found will then fallback to a cookie.
 */
Session.get = (defaultValue = null, key = LOCAL_STORAGE_SESSION_KEY) =>
  getTokenFromStorage(key) || getTokenFromCookie() || defaultValue;

/**
 * @name set
 * @description
 * Method that sets the provided session on localStorage. The
 * payload is first converted to string.
 */
Session.set = ({ accessToken, expiresAt }, key = LOCAL_STORAGE_SESSION_KEY) => {
  localStorage.setItem(key, JSON.stringify({ accessToken, expiresAt }));
};

/**
 * @name remove
 * @description
 * Method that removes the session from the storage layer.
 */
Session.remove = () => {
  // Clear all local storage data
  // Note: This was done primarely to clear the lessons spa sessions
  localStorage.removeItem(LOCAL_STORAGE_SESSION_KEY);
  localStorage.removeItem(LOCAL_STORAGE_SESSION_MARKETPLACE_KEY);
  Cookies.remove(COOKIE_SESSION_KEY);
  Cookies.remove(PHP_SESSION_KEY);
};

/**
 * @name demasqueradeFromStorage
 * @description
 * Method that removes the session from the local storage.
 * So it can be filled later by the PHP App.
 */
Session.demasqueradeFromStorage = () => {
  localStorage.removeItem(LOCAL_STORAGE_SESSION_KEY);
  localStorage.removeItem(LOCAL_STORAGE_SESSION_MARKETPLACE_KEY);
};

Session.isExpired = (expiresAt) => expiresAt * 1000 - Date.now() <= 0;

Session.decodeToken = (token) => jwtDecode(token);

export default Session;
